import PropTypes from 'prop-types'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import ConnectorForm from './ConnectorForm'

const CreateUpdateConnector = (props) => {
  return (
    <Modal
      onClose={() => {
        props.setShowModal(false)
      }}
      show={props.showModal}
    >
      <ModalHeader>Update Existing Connector</ModalHeader>
      <ModalBody>
        <ConnectorForm
          onSave={() => {
            props.setShowModal(false)
          }}
        />
      </ModalBody>
    </Modal>
  )
}

CreateUpdateConnector.propTypes = {
  setShowModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
}

export default CreateUpdateConnector
